export const trimDoubleQuotes = (value: string) =>
  value.replace(/^"(.*)"$/, '$1');

export const unescapeQuotes = (value: string) =>
  value.replace(/\\(['"])/g, '$1');

export const escapeUnescapedQuotesAndBackslashes = (value: string) =>
  value.replace(/(?<!\\)(\\{0,1})(['"\\])/g, '\\$2');
